import type { MessageLike } from "./message-parts";

export type KnowledgeView = {
  status: "available" | "empty" | "unavailable";
  sources: { documentId: string; revision: number }[];
};

function record(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === "object" && !Array.isArray(value)
    ? value as Record<string, unknown> : null;
}

/** Read the last server frame, never citations inferred from model prose. */
export function knowledgeOf(message: MessageLike | null | undefined): KnowledgeView | null {
  const part = [...(message?.parts ?? [])].reverse().find(value => record(value)?.type === "data-knowledge");
  const data = record(record(part)?.data);
  const status = record(data?.health)?.status;
  if (status !== "available" && status !== "empty" && status !== "unavailable") return null;
  const sources: KnowledgeView["sources"] = [];
  if (status === "available" && Array.isArray(data?.sources)) {
    for (const value of data.sources.slice(0, 50)) {
      const source = record(value);
      const documentId = source?.document_id;
      const revision = source?.revision;
      if (source?.source_type !== "clinic_knowledge" || typeof documentId !== "string"
        || !/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(documentId)
        || typeof revision !== "number" || !Number.isSafeInteger(revision) || revision < 1) continue;
      if (!sources.some(item => item.documentId === documentId && item.revision === revision)) {
        sources.push({ documentId, revision });
      }
    }
  }
  return { status, sources };
}
